import { render, staticRenderFns } from "./subjectApplied.vue?vue&type=template&id=5f31a80a&scoped=true"
import script from "./subjectApplied.vue?vue&type=script&lang=js"
export * from "./subjectApplied.vue?vue&type=script&lang=js"
import style0 from "./subjectApplied.vue?vue&type=style&index=0&id=5f31a80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31a80a",
  null
  
)

export default component.exports